import { createContext, useContext, useEffect, useState } from "react"

import { Session } from "@supabase/supabase-js"

import supabase from "@/supabase"

interface SessionContextType {
  session: Session | null
}

const SessionContext = createContext<SessionContextType>({
  session: null,
})

export const useSession = () => {
  const context = useContext(SessionContext)
  if (!context) {
    throw new Error("useContext must be used within the SessionProvider!")
  }
  return context
}

type Props = { children: React.ReactNode }
export const SessionProvider = ({ children }: Props) => {
  const [session, setSession] = useState<Session | null>(null)

  useEffect(() => {
    const authStateListener = supabase.auth.onAuthStateChange(async (event, newSession) => {
      setSession(newSession)
    })

    return () => {
      authStateListener.data.subscription.unsubscribe()
    }
  }, [])

  return <SessionContext.Provider value={{ session }}>{children}</SessionContext.Provider>
}
